// Copyright (c) 2022 by Move Closer

import { ComputedRef } from '@vue/composition-api'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface CardProps {
  /**
   * define whether Card should have flex direction column or row
   * @see variantsDirectionRegistry
   */
  direction: string
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum CardDirection {
  Default = 'column',
  Row = 'row'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface UseCardContentProvides {
  /**
   * computed value getting mapped direction of Card
   * @see useCard
   */
  cardDirectionClass: ComputedRef<string>
}
